<!-- A writer's desk under an arched window at dusk. Everything that touches the desk
     stands on it (bases between y=448 and y=516); things outside sit on the hills,
     with their feet tucked under the hill drawn in front of them. -->
<svg class="tsw" viewBox="24 8 528 556" role="img" aria-labelledby="tsw-title">
  <title id="tsw-title">A writer's desk by an open window at dusk: a lamp, a cup of tea and a book that is writing itself.</title>

  <defs>
    <linearGradient id="tsw-sky" x1="0" y1="54" x2="0" y2="434" gradientUnits="userSpaceOnUse">
      <stop offset="0" class="tsw-stop-sky-top"/>
      <stop offset=".55" class="tsw-stop-sky-mid"/>
      <stop offset=".88" class="tsw-stop-sky-low"/>
    </linearGradient>
    <radialGradient id="tsw-sun-glow">
      <stop offset="0" class="tsw-stop-sun" stop-opacity=".9"/>
      <stop offset="1" class="tsw-stop-sun" stop-opacity="0"/>
    </radialGradient>
    <radialGradient id="tsw-lamp-glow">
      <stop offset="0" class="tsw-stop-lamp" stop-opacity=".55"/>
      <stop offset=".45" class="tsw-stop-lamp" stop-opacity=".18"/>
      <stop offset="1" class="tsw-stop-lamp" stop-opacity="0"/>
    </radialGradient>
    <radialGradient id="tsw-pool">
      <stop offset="0" class="tsw-stop-lamp" stop-opacity=".55"/>
      <stop offset="1" class="tsw-stop-lamp" stop-opacity="0"/>
    </radialGradient>
    <linearGradient id="tsw-cone" x1="0" y1="386" x2="0" y2="516" gradientUnits="userSpaceOnUse">
      <stop offset="0" class="tsw-stop-lamp" stop-opacity=".34"/>
      <stop offset="1" class="tsw-stop-lamp" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="tsw-gutter" x1="250" y1="0" x2="290" y2="0" gradientUnits="userSpaceOnUse">
      <stop offset="0" class="tsw-stop-gutter" stop-opacity="0"/>
      <stop offset=".5" class="tsw-stop-gutter" stop-opacity=".22"/>
      <stop offset="1" class="tsw-stop-gutter" stop-opacity="0"/>
    </linearGradient>
    <clipPath id="tsw-glass-clip">
      <path d="M102,434 V232 A178,178 0 0 1 458,232 V434 Z"/>
    </clipPath>
  </defs>

  <!-- Wall, warmed by the lamp -->
  <rect class="tsw-wall" width="560" height="600"/>
  <circle class="tsw-lamp-glow" cx="486" cy="384" r="250" fill="url(#tsw-lamp-glow)"/>

  <!-- ——— The view ——— -->
  <path class="tsw-frame" d="M88,446 V232 A192,192 0 0 1 472,232 V446 Z"/>
  <g clip-path="url(#tsw-glass-clip)">
    <rect x="102" y="40" width="356" height="400" fill="url(#tsw-sky)"/>

    <g class="tsw-stars">
      <path class="tsw-star" d="M178,118 l1.6,4.4 4.4,1.6 -4.4,1.6 -1.6,4.4 -1.6,-4.4 -4.4,-1.6 4.4,-1.6 Z"/>
      <path class="tsw-star tsw-star--2" d="M236,90 l1.1,3 3,1.1 -3,1.1 -1.1,3 -1.1,-3 -3,-1.1 3,-1.1 Z"/>
      <path class="tsw-star tsw-star--3" d="M392,134 l1.3,3.6 3.6,1.3 -3.6,1.3 -1.3,3.6 -1.3,-3.6 -3.6,-1.3 3.6,-1.3 Z"/>
      <circle class="tsw-star tsw-star--4" cx="318" cy="172" r="1.3"/>
      <circle class="tsw-star tsw-star--2" cx="140" cy="200" r="1"/>
    </g>

    <circle cx="318" cy="378" r="78" fill="url(#tsw-sun-glow)"/>
    <circle class="tsw-sun" cx="318" cy="378" r="24"/>

    <!-- A small dragon flies in from beyond the left of the frame and out past the right, then
         comes back a while later. The glass clip hides it while it is outside the window.
         Rendered here as a still glide; DragonFlight animates it in the browser. -->
    <g class="tsw-dragon" [attr.transform]="dragon.transform">
      <path class="tsw-dragon__wing tsw-dragon__wing--far" [attr.d]="dragon.farWing"/>
      <path class="tsw-dragon__body" [attr.d]="dragon.body"/>
      <path class="tsw-dragon__wing" [attr.d]="dragon.nearWing"/>
    </g>

    <path class="tsw-hill-far" d="M102,372 C160,350 210,356 262,366 C318,377 380,346 458,356 V434 H102 Z"/>

    <!-- Mid hill: two pines and a tower, all rooted below the hill line -->
    <g class="tsw-pine-mid">
      <path d="M334,378 L341,400 H327 Z"/>
      <path d="M346,382 L352,400 H340 Z"/>
    </g>
    <!-- A tower on the hill, one window lit; its foot is under the hill line -->
    <g class="tsw-tower">
      <rect class="tsw-tower__wall" x="382" y="372" width="12" height="27"/>
      <path class="tsw-tower__roof" d="M379,373 L388,356 L397,373 Z"/>
      <path class="tsw-tower__flag-pole" d="M388,356 V349"/>
      <path class="tsw-tower__flag" d="M388,349 L394,351 L388,353 Z"/>
      <rect class="tsw-tower__window" x="386" y="379" width="4" height="5" rx="2"/>
    </g>
    <path class="tsw-hill-mid" d="M102,402 C170,384 236,380 300,392 C360,404 410,388 458,384 V434 H102 Z"/>

    <g class="tsw-pine-near">
      <path d="M118,378 L130,424 H106 Z"/>
      <path d="M134,388 L144,424 H124 Z"/>
      <path d="M150,396 L158,424 H142 Z"/>
      <path d="M432,384 L444,424 H420 Z"/>
      <path d="M447,394 L456,424 H438 Z"/>
    </g>
    <path class="tsw-hill-near" d="M102,418 C150,408 200,410 240,416 C290,424 330,414 380,418 C420,421 440,414 458,412 V434 H102 Z"/>

    <!-- Glazing bars and a little glare on the glass -->
    <rect class="tsw-frame" x="276" y="40" width="8" height="400"/>
    <rect class="tsw-frame" x="102" y="246" width="356" height="8"/>
    <path class="tsw-glare" d="M126,226 L196,120 M140,236 L206,136 M314,232 L380,130"/>
  </g>
  <rect class="tsw-sill" x="78" y="440" width="404" height="9" rx="2"/>

  <!-- ——— The desk ——— -->
  <rect class="tsw-desk" x="0" y="449" width="560" height="68"/>
  <ellipse class="tsw-light-pool" cx="456" cy="492" rx="200" ry="44" fill="url(#tsw-pool)"/>
  <rect class="tsw-desk-edge" x="0" y="515" width="560" height="5"/>
  <rect class="tsw-desk-front" x="0" y="520" width="560" height="80"/>

  <!-- Lamp light falling on the desk (behind the objects) -->
  <path class="tsw-cone" d="M444,386 H528 L560,516 H392 Z" fill="url(#tsw-cone)"/>

  <!-- A stack of books with a cup of tea on top -->
  <g class="tsw-stack">
    <rect class="tsw-book tsw-book--teal" x="104" y="466" width="80" height="20" rx="2"/>
    <rect class="tsw-book-band" x="114" y="466" width="4" height="20"/>
    <rect class="tsw-book-band" x="168" y="466" width="4" height="20"/>
    <rect class="tsw-book tsw-book--red" x="112" y="451" width="64" height="15" rx="2"/>
    <rect class="tsw-book-label" x="132" y="455" width="24" height="7" rx="1"/>
    <rect class="tsw-book tsw-book--ochre" x="100" y="439" width="72" height="12" rx="2"/>
  </g>
  <g class="tsw-tea">
    <ellipse class="tsw-saucer" cx="136" cy="438" rx="23" ry="3.5"/>
    <path class="tsw-cup-handle" d="M151,421 C162,420 162,431 149,432"/>
    <path class="tsw-cup" d="M120,417 H152 C152,431 146,437 136,437 C126,437 120,431 120,417 Z"/>
    <ellipse class="tsw-tea-top" cx="136" cy="417.5" rx="16" ry="2.4"/>
  </g>
  <g class="tsw-steam">
    <path class="tsw-steam__curl" d="M131,410 C125,402 137,394 131,386 C126,379 134,372 130,364"/>
    <path class="tsw-steam__curl tsw-steam__curl--2" d="M142,410 C148,402 137,395 143,387 C148,380 140,374 144,367"/>
  </g>

  <!-- The open book on its reading stand -->
  <path class="tsw-cover" d="M270,472 C236,467 204,469 182,474 L176,326 C206,318 240,320 270,328 C300,320 334,318 364,326 L358,474 C336,469 304,467 270,472 Z"/>
  <path class="tsw-page" d="M270,468 C238,463 208,465 186,470 L181,331 C208,324 240,325 270,333 Z"/>
  <path class="tsw-page" d="M270,468 C302,463 332,465 354,470 L359,331 C332,324 300,325 270,333 Z"/>
  <rect x="250" y="330" width="40" height="140" fill="url(#tsw-gutter)"/>

  <text class="tsw-chapter" x="226" y="356" text-anchor="middle">Chapter One</text>
  <path class="tsw-flourish" d="M212,364 C220,361 232,361 240,364"/>
  <g class="tsw-lines">
    <rect x="198" y="374" width="58" height="2.4" rx="1.2"/>
    <rect x="198" y="384" width="60" height="2.4" rx="1.2"/>
    <rect x="198" y="394" width="55" height="2.4" rx="1.2"/>
    <rect x="198" y="404" width="60" height="2.4" rx="1.2"/>
    <rect x="198" y="414" width="34" height="2.4" rx="1.2"/>
    <rect x="204" y="426" width="54" height="2.4" rx="1.2"/>
    <rect x="198" y="436" width="59" height="2.4" rx="1.2"/>
    <rect x="198" y="446" width="44" height="2.4" rx="1.2"/>
  </g>
  <!-- The right-hand page writes itself, once, then waits with a blinking caret. -->
  <g class="tsw-lines tsw-lines--writing">
    <rect x="283" y="346" width="60" height="2.4" rx="1.2" style="--i: 0"/>
    <rect x="283" y="356" width="57" height="2.4" rx="1.2" style="--i: 1"/>
    <rect x="283" y="366" width="61" height="2.4" rx="1.2" style="--i: 2"/>
    <rect x="283" y="376" width="38" height="2.4" rx="1.2" style="--i: 3"/>
    <rect x="289" y="388" width="55" height="2.4" rx="1.2" style="--i: 4"/>
    <rect x="283" y="398" width="60" height="2.4" rx="1.2" style="--i: 5"/>
    <rect x="283" y="408" width="58" height="2.4" rx="1.2" style="--i: 6"/>
    <rect x="283" y="418" width="61" height="2.4" rx="1.2" style="--i: 7"/>
    <rect x="283" y="428" width="26" height="2.4" rx="1.2" style="--i: 8"/>
  </g>
  <rect class="tsw-caret" x="311" y="424.5" width="1.6" height="8" rx=".8"/>

  <rect class="tsw-stand" x="176" y="470" width="190" height="10" rx="2"/>
  <rect class="tsw-stand" x="196" y="480" width="10" height="18"/>
  <rect class="tsw-stand" x="334" y="480" width="10" height="18"/>

  <!-- The thread: off the spool, up into the book as its ribbon -->
  <path class="tsw-thread" d="M189,494 C206,507 228,504 236,490 V464"/>
  <g class="tsw-spool">
    <ellipse class="tsw-spool__flange" cx="178" cy="503" rx="14" ry="4"/>
    <rect class="tsw-spool__thread" x="168" y="487" width="20" height="16"/>
    <path class="tsw-spool__wind" d="M168,491 H188 M168,495 H188 M168,499 H188"/>
    <ellipse class="tsw-spool__flange" cx="178" cy="487" rx="14" ry="4"/>
  </g>

  <!-- Ink and quill -->
  <path class="tsw-quill" d="M398,470 C404,444 414,418 432,392 C434,404 428,426 418,444 C412,454 404,464 400,471 Z"/>
  <path class="tsw-quill-shaft" d="M399,471 C408,446 418,420 432,392"/>
  <rect class="tsw-ink-neck" x="390" y="465" width="13" height="8" rx="1.5"/>
  <path class="tsw-ink" d="M384,473 H409 V492 Q409,497 404,497 H389 Q384,497 384,492 Z"/>
  <rect class="tsw-ink-label" x="389" y="479" width="15" height="9" rx="1"/>

  <!-- The lamp -->
  <rect class="tsw-lamp-metal" x="484" y="380" width="4" height="106"/>
  <path class="tsw-lamp-metal" d="M458,495 Q458,484 486,484 Q514,484 514,495 Z"/>
  <ellipse class="tsw-lamp-metal" cx="486" cy="495" rx="28" ry="3.5"/>
  <path class="tsw-shade" d="M463,342 H509 L530,386 H442 Z"/>
  <path class="tsw-shade-rim" d="M442,386 H530"/>
  <ellipse class="tsw-bulb" cx="486" cy="389" rx="11" ry="5"/>

  <!-- A moth that can't leave the lamp alone -->
  <g class="tsw-moth" [attr.transform]="animate ? null : 'translate(522 414) rotate(100)'">
    @if (animate) {
      <animateMotion dur="9s" repeatCount="indefinite" rotate="auto"
                     path="M486,402 C536,404 538,426 492,428 C446,430 434,406 486,402 Z"/>
    }
    <path class="tsw-moth__wing" d="M0,0 C-3,-6 -8,-6 -6,-1 Z"/>
    <path class="tsw-moth__wing tsw-moth__wing--back" d="M0,0 C-3,6 -8,6 -6,1 Z"/>
  </g>
</svg>
